import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onLogoutResponse } from "./helper";

import { authAtom } from "stores";
import { useSetRecoilState } from "recoil";

const logout = async () => axios.post(Routes.LOGOUT);

export const useLogout = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.LOGOUT_MUT],
    mutationFn: logout,
    onSuccess: () => onLogoutResponse({ setAuth }),
  });
};
